export { default as Img200 } from './processed/200/BelowDeckMed_S4.jpg';
export { default as Img400 } from './processed/400/BelowDeckMed_S4.jpg';
export { default as Imgthumb } from './processed/thumb/BelowDeckMed_S4.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/BelowDeckMed_S4.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/BelowDeckMed_S4.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      4,
      156,
      220
    ],
    "_population": 6644,
    "_hsl": [
      0.5493827160493827,
      0.9642857142857144,
      0.4392156862745098
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      165,
      117
    ],
    "_population": 260,
    "_hsl": [
      0.06722689075630253,
      0.7579617834394905,
      0.692156862745098
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      4,
      68,
      124
    ],
    "_population": 4,
    "_hsl": [
      0.5777777777777778,
      0.9375,
      0.25098039215686274
    ]
  },
  "Muted": {
    "_rgb": [
      95,
      162,
      148
    ],
    "_population": 561,
    "_hsl": [
      0.4651741293532339,
      0.26482213438735175,
      0.503921568627451
    ]
  },
  "LightMuted": {
    "_rgb": [
      203,
      184,
      157
    ],
    "_population": 777,
    "_hsl": [
      0.09782608695652174,
      0.3066666666666665,
      0.7058823529411764
    ]
  },
  "DarkMuted": {
    "_rgb": [
      86,
      50,
      52
    ],
    "_population": 33,
    "_hsl": [
      0.9907407407407408,
      0.26470588235294124,
      0.26666666666666666
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/BelowDeckMed_S4.js